// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { resolveRleventsAccess } from '@/lib/rleventsAccess';

export function usePostLoginRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return async (overrideUserId?: string) => {
    const userId = overrideUserId ?? user?.id;
    if (!userId) return;

    // 1. Honor ?redirect= param if present
    try {
      const url = new URL(window.location.href);
      const redirect = url.searchParams.get('redirect');
      if (redirect && redirect.startsWith('/')) {
        navigate(redirect);
        return;
      }
    } catch {}

    // 2. Route by what RLevents actually knows: admin, staff, or nothing.
    const access = await resolveRleventsAccess(userId);
    if (access.status !== 'ok') {
      // We could not read permissions. Send them to /dashboard, which shows a
      // retry banner — never to "account not set up".
      navigate('/dashboard', { replace: true });
      return;
    }
    navigate(access.landingPath, { replace: true });
  };
}
